import type { OfViewMode } from '@fabric-app/types/resources';

export const SEARCH_VIEW_MODES: OfViewMode[] = ['Detailed', 'Grid', 'List', 'Masonry'];
export const DEFAULT_SEARCH_VIEW_MODE: OfViewMode = 'Detailed';
